<template>
    <div>
        <div class="d-flex align-end space-between">
            <div class="col-10">
                <img :src="energy.icon" class="w-90"/>
            </div>
            <div class="col-80">
                <label class="label-calculators ">
                    {{ energy.label }}
                </label>
                <div class="position-relative ">
                    <input type="number" class="calculator-input-square w-100" placeholder="Consommation" min="0" v-model="result"  @input="$emit('update:modelValue', result)"/>
                    <div class="unit" v-html="energy.unit"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            result:null
        }
    },
    props: {
        energy: Object
    }
}
</script>
<style scoped>
.w-90{
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
}
.unit{
    position:absolute;
    top:50%;
    right: 10px;
    transform: translateY(-50%);
    color: var(--text-color);
    font-family: var(--font);
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28.2px; /* 141% */
}
.calculator-input-square{
    padding-right:60px;
}
@media screen and (max-width: 1500px) {
  
}

@media screen and (max-width: 1300px) {
 
}

@media screen and (max-width: 992px) {
  

}

@media screen and (max-width: 750px) {
  
}
@media screen and (max-width: 600px) {

}
@media screen and (max-width: 600px) {
  .unit{
    font-size:12px;
  }

}
</style>